<div id="test-environment" *ngIf="!isProduction">
	<h5 style="color: red">{{ environmentName }} ENVIRONMENT</h5>
</div>
<nav
	#navbar
	class="navbar navbar-expand-lg"
	[ngClass]="{ 'bg-white': open === true, 'navbar-transparent': open === false }"
>
	<div class="container-fluid">
		<div class="navbar-wrapper">
			<div style="margin-left: 10px !important">
				<button class="btn btn-icon btn-round" (click)="back()" *ngIf="showBackBtn()">
					<i class="nc-icon nc-minimal-left text-center"></i>
				</button>
			</div>

			<div class="navbar-brand">{{ pageTitleService.title$ | async }}</div>
		</div>
		<ul class="nav navbar-nav navbar-right ml-auto">
			<div class="d-flex">
				<li class="d-flex align-items-center" *ngIf="canToggleNewLayout">
					<div class="mt-1 d-flex align-items-center">
						<span class="mr-2 mb-1">New Sidebar</span>
						<p-inputSwitch [(ngModel)]="isNewLayout" (onChange)="layoutService.toggleLayout()"></p-inputSwitch>
					</div>
				</li>
				<a
					*ngIf="showClientSettingsGear"
					class="dropdown-toggle"
					href="#"
					(click)="$event.preventDefault(); openClientSettings()"
					data-toggle="tooltip"
					data-placement="bottom"
					title="Client Settings"
					aria-label="Client Settings"
				>
					<i class="fa fa-cog gold-font-color"></i>
				</a>
				<a
					class="dropdown-toggle"
					href="#pages/shared-grid-layout"
					data-toggle="tooltip"
					data-placement="bottom"
					title="Shared Grid Layouts"
				>
					<i class="fa fa-layer-group gold-font-color"></i>
				</a>
				<li class="dropdown">
					<a
						class="dropdown-toggle"
						data-toggle="dropdown"
						href="#"
						title="Notifications"
						aria-label="Notifications"
						(click)="onNotificationsOpened()"
						><i class="fa fa-bell gold-font-color" style="font-size: 1.6em"></i
						><sup class="notification" *ngIf="unreadNotificationCount > 0">{{ unreadNotificationCount }}</sup>
					</a>
					<ul class="dropdown-menu">
						<li *ngFor="let alert of chatAlerts">
							<a [href]="alert.link">
								<i class="fa fa-comments"></i>
								{{ alert.title }} &mdash; {{ alert.unreadCount }} new
								{{ alert.kind === 'RegistrationInquiry' ? 'registration' : 'vendor' }} message{{
									alert.unreadCount === 1 ? '' : 's'
								}}
							</a>
						</li>
						<li *ngFor="let announcement of announcements">
							<a href="/#/announcements/view">{{ announcement.title }}</a>
						</li>
						<li><a href="/#/announcements/view">All Announcements</a></li>
					</ul>
				</li>
				<li class="dropdown dropdown-with-icons">
					<a data-toggle="dropdown" href="#" class="dropdown-toggle" aria-expanded="false"
						><i class="fa fa-list gold-font-color"></i
					></a>
					<ul class="dropdown-menu dropdown-with-icons postion-absolute">
						<li>
							<a routerLink="/profile-settings" routerLinkActive="active" (click)="closeDropdown($event)"
								><i class="fa fa-user-cog"></i> Profile Settings
							</a>
						</li>
						<li (click)="logout()">
							<a href="javascript:void(0)" class="text-danger"><i class="fa fa-sign-out-alt"></i> Logout </a>
						</li>
					</ul>
				</li>
			</div>
		</ul>
	</div>
</nav>
